// 작업 목록 테이블 스타일
export const tableStyles = {
  // 우측 목록 컨테이너
  listContainer: {
    flex: 1,
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden' // 컨테이너는 고정
  },
  
  // 섹션 타이틀
  sectionTitle: {
    margin: '0 0 15px 0',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#2c3e50',
    borderBottom: '2px solid #3498db',
    paddingBottom: '8px'
  },
  
  // 필터 바
  filterBar: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    padding: '15px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    marginBottom: '15px',
    flexWrap: 'wrap',
    flexShrink: 0 // 크기 고정
  },
  
  searchInput: {
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white'
  },
  
  dateInput: {
    padding: '8px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white'
  },
  
  selectInput: {
    padding: '8px 12px',
    fontSize: '14px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    backgroundColor: 'white',
    cursor: 'pointer'
  },
  
  resetButton: {
    padding: '8px 16px',
    backgroundColor: '#95a5a6',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px'
  },
  
  // 통계 바
  statsBar: {
    padding: '10px 15px',
    backgroundColor: '#ecf0f1',
    borderRadius: '6px',
    marginBottom: '15px',
    fontSize: '14px',
    color: '#2c3e50',
    flexShrink: 0 // 크기 고정
  },
  
  // 테이블 영역 (스크롤 가능)
  tableWrapper: {
    flex: 1,
    overflowY: 'auto', // 독립 스크롤
    overflowX: 'auto'
  },
  
  // 테이블
  responsiveTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
    backgroundColor: 'white'
  },
  
  tableHeader: {
    backgroundColor: '#34495e',
    color: 'white',
    padding: '12px',
    textAlign: 'left',
    fontWeight: 'bold',
    position: 'sticky',
    top: 0,
    zIndex: 10
  },
  
  tableRow: {
    borderBottom: '1px solid #ecf0f1',
    cursor: 'pointer',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#f8f9fa'
    }
  },
  
  tableCell: {
    padding: '12px',
    color: '#2c3e50'
  },
  
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  
  // 상태 배지
  statusBadge: (status) => {
    const colors = {
      '진행': { bg: '#cfe2ff', color: '#084298', border: '#0d6efd' },
      '완결': { bg: '#d1e7dd', color: '#0f5132', border: '#198754' },
      '미수': { bg: '#e7d4f5', color: '#6f42c1', border: '#9b59b6' },
      '취소': { bg: '#fff3cd', color: '#856404', border: '#ffc107' }
    };
    
    const style = colors[status] || colors['진행'];
    
    return {
      display: 'inline-block',
      padding: '4px 12px',
      fontSize: '12px',
      fontWeight: 'bold',
      borderRadius: '12px',
      backgroundColor: style.bg,
      color: style.color,
      border: `1px solid ${style.border}`
    };
  }
};
